import { secureRoute } from '@uag/react-core';
import { Route, Routes } from 'react-router-dom';

import { Home } from './Home';
import { NotFound } from './NotFound';
import { Unauthorized } from './Unauthorized';

const secureHome = secureRoute(Home);

export const AppRoutes = () => {
    return (
        <Routes>
            <Route Component={secureHome} path="/:tab" />
            <Route Component={secureHome} path="/" />
            <Route Component={Unauthorized} path="/unauthorized" />
            <Route Component={NotFound} path="/notFound" />
        </Routes>
    );
};
